import { Configuration, LogLevel } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || "8eb5e7bf-7a16-4ace-afb2-d8f83edd2765";
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "18846dbb-bf3d-4dd3-83ed-7179da9687a0";

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(`[MSAL ${level}] ${message}`);
      },
    },
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/.default`],
};

export const apiTokenRequest = {
  scopes: [`api://${clientId}/.default`],
};
